import { render, staticRenderFns } from "./Wishes.vue?vue&type=template&id=c680e5c4"
import script from "./Wishes.vue?vue&type=script&lang=js"
export * from "./Wishes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports